<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { EventManager } from "@events";

const props = defineProps({
  rtcId: {
    type: String,
    required: true,
  },
  sectionType: {
    type: String,
    required: false,
  },
  modelValue: {
    type: Object,
    required: false,
  },
});

let actionEmitter = null;

const snackbar = ref(false);
const snackBarText = ref("");
const snackBarColor = ref("");

let onShowSnackbar = null;

onMounted(() => {
  actionEmitter = EventManager.getActionEmitter(props.rtcId);

  onShowSnackbar = (data) => {
    showSnackbar(data.text, data.color);
  };

  actionEmitter.on("snippet-show-snackbar", onShowSnackbar);
});

onUnmounted(() => {
  if (actionEmitter && onShowSnackbar) {
    actionEmitter.off("snippet-show-snackbar", onShowSnackbar);
  }
});

function showSnackbar(text, color = "green") {
  snackbar.value = true;
  snackBarText.value = text;
  snackBarColor.value = color;
}
</script>

<template>
  <v-snackbar :color="snackBarColor" v-model="snackbar" :timeout="2000">
    {{ snackBarText }}

    <template v-slot:actions>
      <v-btn variant="text" @click="snackbar = false">
        {{ $t("Close") }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<style scoped>
</style>
